import { app } from '../../../app';
import { Controller } from './saml-login.controller';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.login-saml-with-app-id', {
        url: '/loginSAML/:applicationId',
        templateUrl: require('./saml-login.html'),
        controller: Controller,
    });

    $stateProvider.state('public.old-login', {
        url: '/oldLogin',
        templateUrl: require('../old-login.html'),
        controller: Controller,
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-login/saml-login.state.js